import { Interface, Page } from "@zapier/canvas-state";
import { isProduction } from "./environment";

export function publishedProjectUrl(project: Interface, page?: Page | null) {
  let domain = "staging.zapier.app";
  if (isProduction) domain = "zapier.app";

  let url = `https://${project.slug}.${domain}`;
  if (page) url += `/${page.slug}`;

  return url;
}
